import React from 'react';
import { RouterProvider } from 'react-router-dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';


import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// Custom css file
import './App.scss';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //
//
// Auth is wired in src/index.jsx via <ClerkProvider> which wraps this
// whole tree. The old <JWTProvider> from contexts/JWTContext used to
// also wrap App but was a dead-code path (its login/logout state was
// never populated once the Clerk migration landed).

const App = () => (
  <ThemeCustomization>
    {/* <RTLLayout> */}
    <Locales>
      <ScrollTop>
        <Notistack>
          <RouterProvider router={router} />
          <Snackbar />
        </Notistack>
      </ScrollTop>
    </Locales>
    {/* </RTLLayout> */}
  </ThemeCustomization>
);

export default App;